import React from "react";
import { GoogleMap } from "react-google-maps";
import MarkerClusterer from "react-google-maps/lib/components/addons/MarkerClusterer";
import { clustersStyles } from "../../styles/map/clustersStyles";
import { mapStyle } from "../../styles/map/mapStyle";
import Partner from "../../types/Partner";
import MarkerComponentContainer from "../marker/MarkerComponentContainer";

interface MapProps {
  partners: Partner[];
  bounds: google.maps.LatLngBounds;
  forwardedRef: React.MutableRefObject<GoogleMap>;
}

const Map = (props: MapProps) => {
  const { partners, forwardedRef } = props;
  return (
    <>
      <MarkerClusterer
        averageCenter
        enableRetinaIcons
        gridSize={60}
        styles={clustersStyles}
      >
        <GoogleMap
          defaultOptions={{
            styles: mapStyle
          }}
          defaultZoom={6}
          defaultCenter={{ lat: 51.912126, lng: 19.649813 }}
          ref={forwardedRef}
        >
          <MarkerComponentContainer partners={partners} />
        </GoogleMap>
      </MarkerClusterer>
    </>
  );
};

export default Map;
